import React, { useContext, useEffect, useState } from 'react';
import { shuffle } from 'lodash';
import * as c from '../../ts/const';
import ColumnItemGroup from '../components/column-item-group';
import { SaleItemsContext } from '../';
import ImgPictures from '../components/img-pictures';
/**
 * コラムマップの中身を配列にして返す
 * @param columItemListMap
 */
function getColumnItemList(columItemListMap) {
    let result = [];
    for (const key of Object.keys(columItemListMap)) {
        result = result.concat(columItemListMap[key]);
    }
    return result;
}
const Column = () => {
    const [saleItemsState] = useContext(SaleItemsContext);
    const [columnItemList, setColumnItemList] = useState([]);
    useEffect(() => {
        if (saleItemsState && saleItemsState.columnItems) {
            // マップからアイテムをリスト形式で抽出して、さらにシャッフルする
            const shuffledColumnItemList = shuffle(getColumnItemList(saleItemsState.columnItems));
            // シャッフルした配列から４つ取り出してセット
            if (!c.IS_DEV) {
                setColumnItemList(shuffledColumnItemList.slice(0, 4));
            }
            else {
                // 開発環境では全件表示
                setColumnItemList(shuffledColumnItemList);
            }
        }
    }, [
        saleItemsState
    ]);
    return (React.createElement("div", null, (columnItemList.length > 0) && (React.createElement("div", { className: "column" },
        React.createElement("div", { className: "a-sale-header" },
            React.createElement("div", { className: "base-width" },
                React.createElement(ImgPictures, { fileNameLarge: `./assets/img/head/column-md`, fileNameSmall: `./assets/img/head/column-sm`, mediaQueryLarge: c.MEDIA_QUERY_LARGE, mediaQuerySmall: c.MEDIA_QUERY_SMALL, alt: "\u30B9\u30AF\u30A6\u30A7\u30A2\u30FB\u30A8\u30CB\u30C3\u30AF\u30B9 \u30B3\u30E9\u30E0" }))),
        React.createElement("div", { className: "column-body" },
            React.createElement("div", { className: "column-lead text-center gutter" },
                React.createElement("div", null,
                    "\u3069\u306E\u30BF\u30A4\u30C8\u30EB\u3092\u8CB7\u304A\u3046\u304B\u60A9\u3093\u3067\u3044\u308B\u65B9\u306F",
                    React.createElement("br", null),
                    "\u30B9\u30AF\u30A6\u30A7\u30A2\u30FB\u30A8\u30CB\u30C3\u30AF\u30B9\u30B3\u30E9\u30E0\u3082\u30C1\u30A7\u30C3\u30AF\uFF01")),
            React.createElement("div", null,
                React.createElement(ColumnItemGroup, { columnItemList: columnItemList })),
            React.createElement("div", { className: "column-navblock base-width" },
                React.createElement("a", { className: "btn-rounded btn-rounded-dark", href: "https://www.jp.square-enix.com/column/?utm_source=2022WINTERSALE&utm_medium=saleLP&utm_campaign=2022WINTERSALE", target: "_blank", id: 'COLUMN_00' }, "\u30B3\u30E9\u30E0\u3092\u30C1\u30A7\u30C3\u30AF\u3059\u308B")))))));
};
export default Column;
